import {sleep, useMock} from "../utils/helpers";
import http from "../plugins/http";
import config from '../config';

const uri = config.services.rating;

class Forecasts {
  constructor() {
    this.useMock = useMock('assets');
  }

  async fetchForecasts(filter) {
    const params = {};

    params.limit = filter.limit || 25;
    params.page = filter.page || 1;
    params.sort = filter.sort || '';
    params.type = filter.type || 'all';

    const {data} = await http.get(`${uri}/api/v1/forecasts/list`, { params });

    return data.data;
  }

  async sendPrediction(id, data) {
    await http.post(`${uri}/api/v1/forecasts/${id}/prediction`, data);
  }

  async getForecastPrediction(id) {
    const {data} = await http.get(`${uri}/api/v1/forecasts/${id}/prediction`);

    return data.data;
  }

  async getForecastsList(filter) {
    const params = {};
    params.limit = filter.limit || 25;
    params.page = filter.page || 1;

    const {data} = await http.get(`${uri}/api/v1/user/forecasts/list`, { params });
    return data.data;
  }
}

export default new Forecasts();



// WEBPACK FOOTER //
// ./src/services/forecasts.js